function BarGroup(props) {
    const style = {
        width: (props.data.value / props.max) * 100 + '%'
    }
    return (
        <div class="bar-chart__bar-wrapper">
            <div class="bar-chart__bar-label">
                {props.data.name}
            </div>
            <div class="bar-chart__bar-inner-wrapper">
                <div style={style} class="bar-chart__bar">{props.data.value}</div>
            </div>
        </div>
    );
}

export default BarGroup;